<ng-container *ngIf="transbankAccepted || mercadopagoAccepted || klapAccepted">
  <div class="flex justify-end">
    <app-close-chip (closed)="dialog.closeAll()" />
  </div>
  <h2 mat-dialog-title class="text-title text-center">{{ 'components.card_inscription_selection.title' | translate }}</h2>
  <div mat-dialog-content>
    <div class="text-primary text-body-md text-center pb-3.5">
      {{ (totalAccepted > 1 ?
        'components.card_inscription_selection.description_multiple':
        'components.card_inscription_selection.description_single') | translate }}
    </div>
    <div matRipple *ngIf="klapAccepted" [mat-dialog-close]="true" class="bg-card-background flex items-center gap-3 mb-2 px-3 py-2 rounded border-xxs border-solid border-primary/60 hover:bg-default-light hover:cursor-pointer" (click)="klapInscription()">
      <div class="flex items-center justify-center w-12.5 h-12.5 p-2.5 rounded border-xxs border-solid border-primary/60 bg-card-background shrink-0">
        <img class="max-w-full max-h-full object-contain" src="assets/img/klap_logo.png" alt="Klap">
      </div>
      <div class="flex flex-col justify-center gap-1 flex-1 min-w-0">
        <span class="text-primary text-body-sm font-bold">{{ 'components.card_inscription_selection.card_label' | translate }}</span>
        <span class="text-primary text-caption-sm">{{ 'components.card_inscription_selection.estimated_time' | translate : { minutes: 1 } }}</span>
      </div>
    </div>
    <div matRipple *ngIf="mercadopagoAccepted" [mat-dialog-close]="true" class="bg-card-background flex items-center gap-3 mb-2 px-3 py-2 rounded border-xxs border-solid border-primary/60 hover:bg-default-light hover:cursor-pointer" (click)="mercadopagoInscription()">
      <div class="flex items-center justify-center w-12.5 h-12.5 p-2.5 rounded border-xxs border-solid border-primary/60 bg-card-background shrink-0">
        <img class="max-w-full max-h-full object-contain" src="assets/img/mercadopago_logo.png" alt="Mercado Pago">
      </div>
      <div class="flex flex-col justify-center gap-1 flex-1 min-w-0">
        <span class="text-primary text-body-sm font-bold">{{ 'components.card_inscription_selection.card_label' | translate }}</span>
        <span class="text-primary text-caption-sm">{{ 'components.card_inscription_selection.estimated_time' | translate : { minutes: 1 } }}</span>
      </div>
    </div>
    <div matRipple *ngIf="transbankAccepted" [mat-dialog-close]="true" class="bg-card-background flex items-center gap-3 mb-2 px-3 py-2 rounded border-xxs border-solid border-primary/60 hover:bg-default-light hover:cursor-pointer" (click)="transbankInscription()">
      <div class="flex items-center justify-center w-12.5 h-12.5 p-2.5 rounded border-xxs border-solid border-primary/60 bg-card-background shrink-0">
        <img class="max-w-full max-h-full object-contain" src="assets/img/webpay_logo.png" alt="Webpay">
      </div>
      <div class="flex flex-col justify-center gap-1 flex-1 min-w-0">
        <span class="text-primary text-body-sm font-bold">{{ 'components.card_inscription_selection.card_label' | translate }}</span>
        <span class="text-primary text-caption-sm">{{ 'components.card_inscription_selection.estimated_time' | translate : { minutes: 3 } }}</span>
      </div>
    </div>
  </div>
</ng-container>
